<template>
  <SelectInput
    v-bind="$attrs"
    :value="value"
    :options="options"
    :invalid="isInvalid"
    :placeholder="placeholder"
    :show-reset="false"
    :searchable="false"
    class="w-full"
    data-qa="employee-dropdown-select"
    @input="handleInput"
  />
</template>

<script>
import { SelectInput } from '@bambeehr/pollen';
import { computed } from '@nuxtjs/composition-api';
import usePlanPrices from '@/modules/HomePage/bside/usePlanPrices';

import useRegistration, {
  RegistrationStateNames,
} from '@/modules/SelfServiceRegistration/hooks/useRegistration';

export default {
  components: { SelectInput },
  props: {
    force: {
      type: Boolean,
      default: false,
    },
    isInvalid: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Number of employees',
    },
  },
  setup(_, { emit }) {
    // The six bands Recurly sells (0–19 … 300–500), read from the same catalog the plan screen
    // and payment price from, so every answer prices (BIO-2201). The Stripe sale list this used
    // mixed the Dedicated tiers with the bands, and most of its ranges priced nothing.
    const { bands } = usePlanPrices();
    const { updateRegistration, state: registration } = useRegistration();

    const handleInput = (e) => {
      updateRegistration({
        [RegistrationStateNames.NUM_EMPLOYEES]: e,
      });

      emit('input', e);
    };

    // The six bands only; the "I'm an employee" option is gone (BIO-2210).
    const options = computed(() =>
      bands.value.map(({ label, value }) => ({ label, value }))
    );
    const value = computed(() => registration.numOfEmployees);

    return {
      handleInput,
      options,
      value,
    };
  },
};
</script>
